import { useCallback, useEffect, useMemo, useState } from 'react';
// Custom Hook.
// -----------------------------------------------------------------------------
export const useControlledActions = ({ actions, refOptions, row }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    const [clickedAction, setClickedAction] = useState();
    // Variables.
    // ---------------------------------------------------------------------------
    const actionItems = useMemo(() => {
        const items = actions.filter((action) => {
            if (!action.show) {
                return action;
            }
            return action.show(row.original);
        });
        return items;
    }, [actions, row]);
    const hasIcons = useMemo(() => actions.every((action) => action.icon), [actions]);
    // Functions.
    // ---------------------------------------------------------------------------
    const handleOnClickCTA = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);
    const handleOnClickAction = useCallback(async (action, event) => {
        if (!clickedAction) {
            if (action.isAsync) {
                setClickedAction(action);
            }
            await action.callback(row, event);
            setIsOpen(false);
            setClickedAction(undefined);
        }
    }, [clickedAction, row]);
    const handleOnClickButtonItem = useCallback(async (action, event) => {
        await handleOnClickAction(action, event);
    }, [handleOnClickAction]);
    const handleOnClickLinkItem = useCallback(async (action, event) => {
        event.preventDefault();
        await handleOnClickAction(action, event);
    }, [handleOnClickAction]);
    // Effects.
    // ---------------------------------------------------------------------------
    useEffect(() => {
        // On Esc.
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        // Outside click.
        const handleOutsideClick = (event) => {
            if (refOptions.current &&
                !refOptions.current.contains(event.target)) {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, refOptions]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        actionItems,
        clickedAction,
        hasIcons,
        isAsyncFnClicked: Boolean(clickedAction),
        isOpen,
        onClickCTA: handleOnClickCTA,
        onClickLinkOption: handleOnClickLinkItem,
        onClickButtonOption: handleOnClickButtonItem
    };
};
//# sourceMappingURL=ControlledActions.hooks.js.map